import { FormControl } from '@chakra-ui/react';
import { useClassFiltersStore } from '@stores/classes';
import { useListLocations } from 'hooks/useApiQueries';
import { useCoachStudioParams } from 'hooks/useCoachStudioParams';
import { useLayoutEffect, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export function ClassesFiltersStudios() {
  const { t } = useTranslation();
  const { data: studios, isLoading } = useListLocations();
  const studioId = useClassFiltersStore((state) => state.studioId);
  const setStudioId = useClassFiltersStore((state) => state.setStudioId);
  const { isStudioUrl, id } = useCoachStudioParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Mettre à jour le studioId lorsque l'URL contient un studio
  useLayoutEffect(() => {
    if (isStudioUrl) setStudioId(id);
  }, [isStudioUrl, id, setStudioId]);

  // Observer les changements dans l'URL
  useEffect(() => {
    if (isStudioUrl) {
      const studioPath = `/studio/${id}`;
      const hashIndex = location.pathname.indexOf('#');
      const pathWithoutHash = hashIndex !== -1 ? location.pathname.slice(0, hashIndex) : location.pathname;

      if (pathWithoutHash.includes(studioPath)) {
        const newPath = pathWithoutHash.replace(studioPath, '');
        navigate(newPath, { replace: true });
      }
    }
  }, [location.pathname, isStudioUrl, id, navigate]);

  const options = Array.isArray(studios)
    ? [
        {
          label: t('Tous les studios'),
          value: null,
        },
        ...studios
          .filter((studio) => {
            if (!mondayMindbody.siteId) return true;
            return (
              mondayMindbody.siteId === String(studio.SiteID) &&
              studio.Name.toLowerCase() !== 'bateaux-mouches' &&
              studio.Name.toLowerCase() !== 'maison monday'
            );
          })
          .map((studio) => ({
            label: studio.Name,
            value: studio.Id,
          })),
      ]
    : [];

  const value = options.find((option) => option.value === studioId);

  return (
    <FormControl>
      <Select
        className="studiosSelect"
        placeholder="Changer de studio"
        isLoading={isLoading}
        options={options}
        value={value}
        onChange={(option) => {
          if (option) {
            setStudioId(option.value);
            if (isStudioUrl) {
              const classType = useClassFiltersStore.getState().classType;
              const newPath = window.location.pathname.replace(`/studio/${id}`, '');
              const basePath = `${window.location.origin}${newPath}`;
              window.location.href = classType
                ? `${basePath}#/studio/${option.value}/cours/${classType}`
                : `${basePath}#/studio/${option.value}`;
            }
          }
        }}
      />
    </FormControl>
  );
}
